'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

export default function DraftPoller({ intervalMs = 4000 }: { intervalMs?: number }) {
  const router = useRouter()
  useEffect(() => {
    const id = setInterval(() => router.refresh(), intervalMs)
    return () => clearInterval(id)
  }, [router, intervalMs])
  return null
}
